import { Injectable } from '@angular/core';

export type AppLaunchPlatform = 'ios' | 'android' | 'other';
export type AppLaunchPreference = 'app' | 'browser';

const STORAGE_KEY = 'ai_advisor_app_launch_preference';

const IOS_APP_STORE_URL = 'https://apps.apple.com/us/app/j-j-medtech-ai-advisor/id6756101233';
const ANDROID_APP_SCHEME = 'jjmedtech-aiadvisor';
const ANDROID_PACKAGE_NAME = 'com.jnj.medtech.aiadvisor';
const ANDROID_PLAY_STORE_URL = `https://play.google.com/store/apps/details?id=${ANDROID_PACKAGE_NAME}`;

@Injectable({ providedIn: 'root' })
export class AppLaunchPromptService {

  getPlatform(): AppLaunchPlatform {
    const ua = window.navigator.userAgent || '';
    const isIpadOs13Up = /Macintosh/.test(ua) && navigator.maxTouchPoints > 1;
    if (/iPhone|iPad|iPod/.test(ua) || isIpadOs13Up) {
      return 'ios';
    }
    if (/Android/.test(ua)) {
      return 'android';
    }
    return 'other';
  }

  getStoredPreference(): AppLaunchPreference | null {
    return sessionStorage.getItem(STORAGE_KEY) as AppLaunchPreference | null;
  }

  setStoredPreference(preference: AppLaunchPreference): void {
    sessionStorage.setItem(STORAGE_KEY, preference);
  }

  /** Tries to launch the installed app; falls back to the relevant app/play store if it isn't installed. */
  openApp(platform: AppLaunchPlatform): void {
    if (platform === 'android') {
      const fallbackUrl = encodeURIComponent(ANDROID_PLAY_STORE_URL);
      window.location.href = `intent://open#Intent;scheme=${ANDROID_APP_SCHEME};package=${ANDROID_PACKAGE_NAME};S.browser_fallback_url=${fallbackUrl};end`;
      return;
    }
    if (platform === 'ios') {
      window.location.href = IOS_APP_STORE_URL;
    }
  }
}
